import { Helmet } from 'react-helmet-async'

const SEO = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Janacode",
    "url": "https://janacode.com",
    "logo": "https://janacode.com/logo.png",
    "description": "Janacode specializes in SaaS product development across Sports Tech, Gaming, Lifestyle, Entertainment, Finance, and Marketing. Building innovative solutions for the common man.",
    "foundingDate": "2025",
    "founders": [{
      "@type": "Person",
      "name": "Janacode Team"
    }],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "hello@janacode.com",
      "contactType": "Customer Service"
    },
    "sameAs": [
      "https://janacode.com"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "knowsAbout": [
      "SaaS Development",
      "Sports Technology",
      "Gaming Software",
      "Fintech",
      "Marketing Technology",
      "Product Development"
    ]
  }

  const websiteStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Janacode",
    "url": "https://janacode.com",
    "description": "India's Code, Everyone's Product - Premium SaaS product development company",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://janacode.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  }

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Janacode - India's Code, Everyone's Product | SaaS Product Development</title>
      <meta name="title" content="Janacode - India's Code, Everyone's Product | SaaS Product Development" />
      <meta name="description" content="Janacode specializes in SaaS product development across Sports Tech, Gaming, Lifestyle, Entertainment, Finance, and Marketing. Building innovative solutions for the common man." />
      <meta name="keywords" content="SaaS development, product development, sports tech, gaming software, fintech, marketing tech, India software company, Janacode" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Janacode" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://janacode.com/" />
      <meta property="og:title" content="Janacode - India's Code, Everyone's Product" />
      <meta property="og:description" content="Premium SaaS product development company specializing in Sports Tech, Gaming, Lifestyle, Entertainment, Finance, and Marketing Products." />
      <meta property="og:image" content="https://janacode.com/og-image.jpg" />
      <meta property="og:site_name" content="Janacode" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content="https://janacode.com/" />
      <meta name="twitter:title" content="Janacode - India's Code, Everyone's Product" />
      <meta name="twitter:description" content="Premium SaaS product development company specializing in Sports Tech, Gaming, Lifestyle, Entertainment, Finance, and Marketing Products." />
      <meta name="twitter:image" content="https://janacode.com/twitter-image.jpg" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteStructuredData)}
      </script>
      
      {/* Additional SEO */}
      <link rel="canonical" href="https://janacode.com" />
      <meta name="theme-color" content="#0a1929" />
    </Helmet>
  )
}

export default SEO
